import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import { map } from 'lodash';

function TabPanel({ children, value, index }) {
  return (
    <div hidden={value !== index} role="tabpanel">
      {value === index && (
        <Box p={3}>{children}</Box>
      )}
    </div>
  );
}

export default function TabsView(props) {
  const [value, setValue] = useState(0);
  const { tabs, clickHandler } = props

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (clickHandler) {
      clickHandler(newValue);
    }
  };
  useEffect(() => {
    if (tabs && tabs.length > 0) {
      setValue(0);
      if (clickHandler) {
        clickHandler(0);
      }
    }
  }, [tabs]);

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="fullWidth"
        indicatorColor="primary"
        textColor="primary"
        aria-label="full width tabs"
      >
        {map(tabs, (el, index) => (<Tab
          key={"tab" + index + el.date}
          label={el.title}
          sx={{
            borderBottom: value === index ? '5px solid #586B94' : '5px solid #E2E2E2',
            color: value === index ? '#586B94!important' : '#757575',
            textTransform: 'none',
            transition: 'all 0.3s',
          }}
        />
        ))}
      </Tabs>
    </Box>
  );
}
